export default __webpack_public_path__ + "static/B0231-cd5f907dea2a6546a9cbc25e2a67511f.png";